import { createBrowserRouter } from 'react-router-dom'

import { AppShell } from '@/components/layout/AppShell'

import { HomePageV2 } from '@/pages/HomePage'

import { OverviewView } from './pages/HomePage/OverviewView';
import { OperatorsExplorePage } from './pages/ExplorePages/OperatorsExplorePage';
import { BlobsExplorePage } from './pages/ExplorePages/BlobsExplorePage';
import { EventsExplorePage } from './pages/ExplorePages/EventsExplorePage';

import { OperatorDetailsPage } from './pages/DetailsPages/OperatorDetailsPage';
import { BlobDetailsPage } from './pages/DetailsPages/BlobDetailsPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { 
				path: '', 
				element: <HomePageV2 />, 
				children: [
					{ index: true, element: <OverviewView /> },
					{ path: 'operators', element: <OperatorsExplorePage /> },
					{ path: 'blobs', element: <BlobsExplorePage /> },
					{ path: 'events', element: <EventsExplorePage /> }
				]
			},
			{ path: '/operators/:id', element: <OperatorDetailsPage /> }, 
			{ path: '/blobs/:id', element: <BlobDetailsPage /> }, 
    ],
  },
]);
